

export class ToolTipOptionSelectActiveOutputWithStatus implements IToolTipOptionSelectActiveOutputWithStatus {
    /** The auto-generated id of the tool tip option master master */
    tooltip_option_id!: number;
    /** The tool tip option name  with 255 character limit */
    tooltip_option_name!: string;
    /** Manage status of tool tip option. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IToolTipOptionSelectActiveOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tooltip_option_id = _data["tooltip_option_id"];
            this.tooltip_option_name = _data["tooltip_option_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ToolTipOptionSelectActiveOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ToolTipOptionSelectActiveOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tooltip_option_id"] = this.tooltip_option_id;
        data["tooltip_option_name"] = this.tooltip_option_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IToolTipOptionSelectActiveOutputWithStatus {
    /** The auto-generated id of the tool tip option master master */
    tooltip_option_id: number;
    /** The tool tip option name  with 255 character limit */
    tooltip_option_name: string;
    /** Manage status of tool tip option. 0 For De-active, 1 For Active */
    status: number;
}

